/* PP Daily Summary — yesterday's picked / invoiced / completed counts (+ today so far). */
import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarCheck } from "lucide-react";
import { API, getAuthHeader } from "@/App";

const STATS = [["picked", "picked"], ["invoiced", "invoiced"], ["completed", "completed"], ["handed_back_rows", "handed back"]];

export const PpDailySummary = ({ refreshKey }) => {
  const [d, setD] = useState(null);
  useEffect(() => {
    axios.get(`${API}/order-register/pp/daily-summary`, { headers: getAuthHeader() }).then(r => setD(r.data)).catch(() => {});
  }, [refreshKey]);
  if (!d) return null;
  return (
    <span className="inline-flex items-center gap-2 text-[11px] text-sky-900" data-testid="pp-daily-summary"
      title="Yesterday's 48h+ work (today so far in brackets)">
      <CalendarCheck className="h-3.5 w-3.5 text-sky-600" /> <b>Yesterday:</b>
      {STATS.map(([k, l]) => (
        <span key={k} className="inline-flex items-baseline gap-1 rounded bg-sky-50 px-1.5 py-0.5 ring-1 ring-sky-200" data-testid={`pp-summary-${k}`}>
          <b className="tabular-nums">{d.yesterday[k]}</b>
          <span className="text-[10px] text-sky-700">{l}</span>
          {d.today[k] > 0 && <span className="text-[9px] text-sky-500">+{d.today[k]}</span>}
        </span>))}
    </span>
  );
};
